import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setProfileMeta } from '../../redux/slice/tanProfileSlice';
import { useTranslation } from 'react-i18next';
import { slice_map } from '../../components/componentMap/componentMap';
import SwipeableProfileList from '../../components/profileList/SwipeableProfileList';
import "./tanProfiles.css";

const TanProfiles = () => {
  const { t } = useTranslation("translation", { keyPrefix: "tanProfiles" });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mappedComponents = useSelector((state) => state?.tanProfile?.mappedComponents);
  // document.documentElement.style.setProperty('--navigation-background', "linear-gradient(to bottom, var(--unity-primary-blue) -30%, var(--unity-secondary-violet) 80%)")
  document.documentElement.style.setProperty('--navigation-h1-font', "white")
  return (
    <div className='profiles-container'>
      <div className='profiles-content'>
        {/* Swipable List Component */}
        <SwipeableProfileList
        top={<div className='profiles-top'>
          <div className='profiles-header'>
            <h1>{t("header", "Tan Profiles").toUpperCase()}</h1>
          </div>
          <div className='profile-instructions'>
            <p>{t("instructions.toptext", "Tap a profile to edit, or swipe left to delete")}</p>
          </div>
        </div>}
        deleteable={true}/>

        
      </div>
    </div>
  );
};

export default TanProfiles;
